<template>
  <Drawer
    v-if="props.option.modalType === 'drawer'"
    v-model:open="visible"
    :title="getModalTitle"
    @cancel="onOk"
    width="800px"
  >
    <SmartDetail :option="props.option" :data="modalData" />
    <template #footer>
      <Button @click="onOk">{{lang('关闭')}}</Button>
    </template>
  </Drawer>
  <Modal v-else v-model:open="visible" :title="getModalTitle" @cancel="onOk" width="800px">
    <SmartDetail :option="props.option" :data="modalData" />
    <template #footer>
      <Button @click="onOk">{{lang('关闭')}}</Button>
    </template>
  </Modal>
</template>

<script lang="tsx" setup name="SmartModalDetail">
import { Modal, Button, Drawer } from 'ant-design-vue'
import {computed, inject, ref} from 'vue'
import type { Values } from '../../common'
import SmartDetail from '../smart-detail/index.vue'

const lang = inject('lang')
const type = ref(true)

const props = defineProps({
  option: {
    type: Object,
    required: true
  }
})

const visible = ref(false)
const modalType = ref('view')
const modalData = ref<Values>({})

const showModal = (type = 'view', record = {}) => {
  modalType.value = type
  visible.value = true
  modalData.value = Object.assign({}, record)
}

const onOk = () => {
  visible.value = false
  modalData.value = {}
}

const getModalTitle = computed(() => {
  return '查看'
})

defineExpose({
  showModal
})
</script>
